<body class="location-group-page">
  <!-- Table header -->
  <app-table-header
    [headerText]="CONSTANTS.WELCOME_TEXT"
    [hasNoButtons]="true"
  ></app-table-header>
  <div class="location-table">
    <div class="left-container">
      <!-- Table Header-->
      <app-table-header
        [hasHeader]="false"
        [filterDisabled]="!isFilterEnabled"
        [hasCollapsedPadding]="false"
        (exportExcelEvent)="exportExcel()"
        (clearFilterEvent)="clearAllFilters()"
        (addItemEvent)="addGroup()"
      ></app-table-header>

      <!-- Table -->
      <div class="left-table-container" #webview>
        <table mat-table matSort class="left-table" [dataSource]="dataSource">
          <!-- Group -->
          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef class="group-header">
              <app-table-search-component
                [columnName]="COLUMNTEXT.GROUP"
                [control]="groupData.formControl"
                [maxLength]="30"
                [placeholder]="CONSTANTS.SEARCH_GROUP_PLACEHOLDER"
                (emitSearch)="search()"
              ></app-table-search-component>
            </th>
            <td
              mat-cell
              *matCellDef="let location; let i = index"
              headers="group-headers"
              class="left-data-column"
            >
              <div class="text-container">{{ location?.code }}</div>
            </td>
          </ng-container>

          <!-- Description -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="description-header">
              <app-table-search-component
                [columnName]="COLUMNTEXT.DESCRIPTION_COL"
                [control]="descriptionData.formControl"
                [maxLength]="20"
                [placeholder]="CONSTANTS.SEARCH_DESC_PLACEHOLDER"
                (emitSearch)="search()"
              ></app-table-search-component>
            </th>

            <td
              mat-cell
              *matCellDef="let location; let i = index"
              headers="description-headers"
              class="left-data-column"
            >
              <div [title]="location.name">
                {{ location?.name | slice: 0 : 30 }}
                {{ location?.name?.length > 30 ? "..." : "" }}
              </div>
            </td>
          </ng-container>

          <!-- Number of Sites. -->
          <ng-container matColumnDef="siteCount">
            <th mat-header-cell *matHeaderCellDef class="no-of-site-header">
              <app-table-search-component
                [columnName]="COLUMNTEXT.SITE_COUNT"
                [control]="noOfSiteData.formControl"
                [maxLength]="20"
                [placeholder]="CONSTANTS.ENTER"
                [rightAlign]="true"
                (emitSearch)="search()"
              ></app-table-search-component>
            </th>

            <td
              mat-cell
              *matCellDef="let location; let i = index"
              headers="noOfSites-headers"
              class="align-right"
            >
              {{ location?.siteCount }}
            </td>
          </ng-container>

          <!-- Action -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>
              <ion-row class="action-header">
                {{ COLUMNTEXT.ACTION }}
              </ion-row>
              <ion-row class="empty-block"></ion-row>
            </th>
            <td
              mat-cell
              *matCellDef="let location; let i = index"
              headers="action-headers"
              class="action-data"
            >
              <ion-button
                class="view-btn"
                fill="clear"
                (click)="getLinkedSite(location, i)"
                onkeypress="getLinkedSite(location, i)"
              >
                <span class="btn-text">{{ CONSTANTS.VIEW_SITE }}</span>
                <ion-icon
                  class="icon"
                  src="assets\right-arrows!.svg"
                ></ion-icon>
              </ion-button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns; let i = index"
            [ngClass]="{
              'selected-row': i === selectedIndex,
            }"
          ></tr>

          <tr class="mat-row no-data-row" *matNoDataRow>
            <td
              class="mat-cell no-border"
              [attr.colspan]="displayedColumns.length"
            >
              <app-no-results-found></app-no-results-found>
            </td>
          </tr>
        </table>
      </div>
      <app-table-pagination [datasource]="dataSource"></app-table-pagination>
    </div>
    <div class="right-container">
      @if (selectedGroup) {
        <app-linked-sites
          [group]="selectedGroup"
          [isDeleteDisabled]="isDeleteDisabled"
          (linkSiteChanges)="getLocationGroup()"
        ></app-linked-sites>
      }
    </div>
  </div>
</body>
